export enum IncludeModeEnum {
  dynamicOr = 0,
  dynamicAnd = 1,
  static = 2,
}
